import { useQuery } from "@tanstack/react-query";
import { getAppVersion } from "@Http/app_version";

import { CURRENT_VERSION } from "../types/version";

const isVersionBehind = (current: string, latest: string): boolean => {
  const c = current.split(".").map(Number);
  const l = latest.split(".").map(Number);
  for (let i = 0; i < 3; i++) {
    if ((c[i] ?? 0) < (l[i] ?? 0)) return true;
    if ((c[i] ?? 0) > (l[i] ?? 0)) return false;
  }
  return false;
};

const useCheckVersion = () => {
  const { data } = useQuery({
    queryKey: ["app-version"],
    queryFn: getAppVersion("lender"),
  });

  if (!data) return { hasUpdate: false, force: false };

  const hasUpdate = isVersionBehind(CURRENT_VERSION, data.version);
  return { hasUpdate, force: hasUpdate && data.force };
};

export default useCheckVersion;
